import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CollectionSwatch extends ThemeComponent {
    init() {
        this.initializeSwatches();
        this.setupProductCardEventListeners();
    }

    initializeSwatches() {
        const swatches = document.querySelectorAll<HTMLElement>('.metafield-color-array .metafield-colour');
        for (const swatch of swatches) {
            this.applySwatchColor(swatch);
            this.setupSwatchClickListener(swatch);
        }
    }

    applySwatchColor(swatch: HTMLElement) {
        const parentSwatch = swatch.closest<HTMLElement>('.product-card');
        const allColorAttrs = parentSwatch?.dataset || {};
        const swatchColor = swatch.getAttribute('data-color-swatch') || '';

        for (const [key, value] of Object.entries(allColorAttrs)) {
            if (key.toLowerCase().includes(swatchColor)) {
                swatch.classList.add('image-applied-swatch');
            }
        }
    }

    setupSwatchClickListener(swatch: Element) {
        swatch.addEventListener('click', () => {
            const parent = swatch.closest('.product-card');
            if (parent) {
                const swatchColor = swatch.getAttribute('data-color-swatch');
                const variantImageUrl = parent?.getAttribute(`data-${swatchColor}-swatch`);
                if (!variantImageUrl) {return;}
                const imageWrapper = parent.querySelector('.product-card__image');
                if (imageWrapper) {
                    this.updateImages(imageWrapper, variantImageUrl);
                }
            }
        });
    }

    updateImages(imageWrapper: Element, variantImageUrl: string) {
        const [imageToHide, imageToUpdate] = Array.from(imageWrapper.children);

        if (imageToUpdate) {
            imageToUpdate.setAttribute('src', variantImageUrl);
            imageToUpdate.setAttribute('srcset', variantImageUrl);
            (imageToUpdate as HTMLElement).style.opacity = '1';
        }

        if (imageToHide) {
            (imageToHide as HTMLElement).style.opacity = '0';
        }
    }

    setupProductCardEventListeners() {
        const productCards = document.querySelectorAll('.product-card');

        for (const productCard of productCards) {
            productCard.addEventListener('mouseleave', () => {
                this.resetImageOnMouseLeave(productCard);
            });
        }
    }

    resetImageOnMouseLeave(productCard: Element) {
        const mainImageSrc = productCard.getAttribute('data-original-src');
        const imageWrapper = productCard.querySelector('.product-card__image');

        if (imageWrapper) {
            const [rolloverImage, mainImage] = Array.from(imageWrapper.children);

            if (mainImage) {
                mainImage.setAttribute('src', mainImageSrc || '');
                mainImage.setAttribute('srcset', mainImageSrc || '');
                (mainImage as HTMLElement).removeAttribute('style');

                if (rolloverImage) {
                    (rolloverImage as HTMLElement).removeAttribute('style');
                }
            }
        }
    }
}
